import { QuestionCircleOutlined } from '@ant-design/icons';
import ModuleCard from 'components/cards/ModuleCard';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from 'components/ui/dialog';
import useSymptomTrackingData from 'hooks/useSymptomTrackingData';
import posthog from 'posthog-js';
import React, { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

const NextPeriodPrediction: React.FC = () => {
  const { t } = useTranslation();
  const [showPeriodPredictionHelp, setShowPeriodPredictionHelp] = useState(false);
  const { nextPeriodPrediction, cycleStats } = useSymptomTrackingData();

  const { predictionLabel, predictionValue } = nextPeriodPrediction;

  return (
    <div className="relative w-fit text-center">
      <ModuleCard block={false} bodyStyle={{ padding: '16px 24px 12px' }}>
        <p className="text-sm text-muted-foreground">{predictionLabel}</p>
        <p className="m-0 text-3xl font-bold">{predictionValue}</p>
        <p className="m-0 text-sm font-medium text-subtle-foreground">
          {cycleStats.roundedStandardDeviation >= 1 && (
            <Trans
              i18nKey="symptomTracking.nextPeriod.plusMinusDays"
              values={{ plusMinusDays: cycleStats.roundedStandardDeviation }}
              count={cycleStats.roundedStandardDeviation}
            />
          )}
        </p>
      </ModuleCard>
      <div className="absolute top-0 -right-6 text-subtle-foreground">
        <QuestionCircleOutlined
          data-testid="tracking.next-period-prediction.help"
          onClick={() => {
            setShowPeriodPredictionHelp(true);
            posthog.capture('tracking.period_prediction_help_opened');
          }}
        />
        <Dialog open={showPeriodPredictionHelp} onOpenChange={open => !open && setShowPeriodPredictionHelp(false)}>
          <DialogContent aria-describedby={undefined}>
            <DialogHeader>
              <DialogTitle>{t('symptomTracking.nextPeriod.helpTitle')}</DialogTitle>
            </DialogHeader>
            <p>
              <Trans i18nKey="symptomTracking.nextPeriod.help" components={{ br: <br /> }} />
            </p>
          </DialogContent>
        </Dialog>
      </div>
    </div>
  );
};

export default NextPeriodPrediction;
